<template>
  <div id="password-reset-view">
    <md-card class="md-layout-item md-size-40 md-small-size-100 md-elevation-5">
      <md-card-header>
        <h1>Réinitialiser le mot de passe</h1>
      </md-card-header>
      <md-card-content>
        <template v-if="emailLoading">
          chargement...
        </template>
        <template v-else-if="!emailCompleted">
          <form @submit.prevent="submit">
            <md-field>
              <label for="email">E-mail</label>
              <md-input
                v-model="inputs.email"
                type="text"
                id="email" />
            </md-field>
            <span
              class="error"
              v-show="emailError">
              Une erreur s'est produite lors du traitement de votre demande.
            </span>
          </form>
        </template>
        <template v-else>
          <div>
            Vérifiez votre boîte de réception pour un lien pour réinitialiser votre mot de passe. Si un e-mail n'apparaît pas dans quelques minutes, vérifiez votre dossier spam.
          </div>
          <router-link to="/login">
            retourner à la page de connexion
          </router-link>
        </template>
      </md-card-content>
      <md-card-actions>
        <md-button
          @click="sendPasswordResetEmail(inputs)"
          class="md-primary">
          Recevoir un email de ré-initialisation
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return { inputs: { email: '' } }
  },
  created () {
    var app = this
    app.$store.dispatch('routing/update_title', 'Réinitialiser le mot de passe')
    app.$store.dispatch('routing/update_return_kwargs', null)
  },
  computed: mapState('password', [
    'emailCompleted',
    'emailError',
    'emailLoading'
  ]),
  methods: mapActions('password', [
    'sendPasswordResetEmail',
    'clearEmailStatus'
  ]),
  beforeRouteLeave (to, from, next) {
    this.clearEmailStatus()
    next()
  }
}
</script>

<style scoped lang="scss">
#password-reset-view {
  position: relative;
  padding-top: 5vh;
  height: 100%;
  .md-card {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -30%);
  }
}
.md-card-header {
  border-bottom: 1px solid #eee;
  margin-top: 2px;
}
.md-card-content {
  padding-top: 20px;
}
.md-card-actions {
  padding: 15px;
  border-top: 1px solid #eee;
  background: #f5f5f5;
}
.error {
  color: crimson;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/PasswordReset.vue